import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { Button } from '../../../../components/Button';

export const StyledContactUsHistorycalDataButton = styled(Button)`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colorsPalettes.sky[100]};
  color: ${colorsPalettes.indigo[300]};
  border-radius: 6px;
  &:hover,
  &:active {
    background-color: ${colorsPalettes.sky[200]};
  }
`;

export const StyledIcon = styled(SWReactIcons)`
  min-width: 22px;
  margin-right: 8px;
`;

export const StyledTextBlock = styled.div`
  font-weight: 500;
  text-align: left;
`;
